import { Fragment } from 'react';

/**
 * Substring-highlight renderer. Splits `text` on `query` (case-
 * insensitive) and wraps the matches in a `.highlight` span — the
 * yellow-tinted style is defined in `src/index.css` and already
 * dark-mode aware (orange-toned amber-600 in dark mode).
 *
 * No-op when `query` is empty / shorter than 2 characters — short
 * queries match too many noise positions and the highlight becomes
 * visual chatter.
 */
export function HighlightedText({ text, query }: { text: string; query: string }): JSX.Element {
  const q = query.trim();
  if (q.length < 2 || !text) return <>{text}</>;
  const pattern = new RegExp(`(${escapeRegex(q)})`, 'gi');
  const parts = text.split(pattern);
  return (
    <>
      {parts.map((part, i) =>
        pattern.test(part) ? (
          <span key={i} className="highlight">
            {part}
          </span>
        ) : (
          <Fragment key={i}>{part}</Fragment>
        ),
      )}
    </>
  );
}

function escapeRegex(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
